import { SVGProps } from 'react';
export const MobileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M20.581 6.492v3.902a1.207 1.207 0 0 0 1.084 1.3h8.67a1.207 1.207 0 0 0 1.084-1.3V6.492m-9.754 32.514h8.67m4.335 6.502H17.33a4.335 4.335 0 0 1-4.336-4.335V10.827a4.335 4.335 0 0 1 4.335-4.335h17.34a4.335 4.335 0 0 1 4.336 4.335v30.346a4.335 4.335 0 0 1-4.335 4.335Z'
    />
  </svg>
);
